<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-question-circle"></i>
          Q &amp; A
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Board</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Q &amp; A</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> Q &amp; A
      </template> -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="5">
            From
            <b-form >
              <date-picker v-model="so.opt.created_at_sd" style="width: 80%" :lang="custom.lang.en" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="5">
            To
            <b-form >
              <date-picker v-model="so.opt.created_at_ed" style="width: 80%" :lang="custom.lang.en" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="2">
            <b-form class="m-2"> <span>カテゴリー</span> </b-form>
          </b-col>
          <b-col md="2">
            <b-form class="m-2">
            <label for="webcastle">
              <input type="radio" value="webcastle" id="webcastle" v-model="so.opt.type" @click="so.sk='type'"> WEBCastle
            </label>
            </b-form>
          </b-col>
          <b-col md="2"> <b-form class="m-2">
            <label for="wsfinder">
              <input type="radio" value="webcastle" id="webcastle" v-model="so.opt.type" @click="so.sk='type'"> WSFinder
            </label>
            </b-form>
          </b-col>
          <b-col md="2"> <b-form class="m-2">
            <label for="wmds">
              <input type="radio" value="wmds" id="wmds" v-model="so.opt.type" @click="so.sk='type'"> WMDS
            </label>
            </b-form>
          </b-col>
          <b-col md="2"> <b-form class="m-2">
            <label for="wfdetector">
              <input type="radio" value="wfdetector" id="wfdetector" v-model="so.opt.type" @click="so.sk='type'"> WFDetector
            </label>
            </b-form>
          </b-col>
          <b-col md="2"> <b-form class="m-2">
            <label for="etc">
              <input type="radio" value="etc" id="etc" v-model="so.opt.type" @click="so.sk='type'"> ETC
            </label>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>タイトル</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_remote_addr" v-model="so.opt.title" :placeholder="'タイピングタイプ'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>質問</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_target" v-model="so.opt.question" :placeholder="'質問の入力'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>

        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh"> 検索 </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> リセット </b-button>
          <b-button size="sm" variant="dark" @click="so.adv = false"> 閉じる </b-button>
        </b-form-group>
      </b-card>
      <b-row>
        <b-col sm="6">
          <!-- <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" /> -->
          <span>サービスを選択</span>
          <select v-model="search_type" @change="$refs._list.refresh()">
            <option disabled value="">サービスを選択してください</option>
            <option value="webcastle">WEBCastle : Webファイアウォール</option>
            <option value="wsfinder">WSFinder : アンチWebシェル</option>
            <option value="wmds">WMDS : Webマルウェア検出システム</option>
            <option value="wfdetector">WFDetector : Web偽造検出</option>
            <option value="etc">Etc</option>
          </select>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '検索'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='title';so.skt='title'">タイトル</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='question';so.skt='question'">質問</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-input v-model="so.sv" @keyup.enter="refresh"></b-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> 詳細検索</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <!-- <b-row>
        <b-col>
          <span class="text-danger font-weight-bold"> タイトルをクリックすると詳細情報が表示されます </span>
        </b-col>
      </b-row>
      <hr> -->

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="type" slot-scope="row">{{codes.BOARD_TYPE[row.item.type]}}</template>
        <template slot="title" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="() => detail(row.item)">
            {{row.item.title}}
          </a>
          <!-- <span  style="cursor: pointer;">{{row.item.title}}</span> -->
        </template>
        <template slot="is_answered" slot-scope="row">
          <i class="fa fa-check" v-if="row.item.is_answered"></i>
          <span v-else>-</span>
        </template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | date}}</template>
        <!-- <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">詳細</b-btn>
        </template> -->
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-2"></b-col>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
        <b-col class="md-2">
          <div class="pull-right">
            <b-button size="sm" variant="success" @click="$router.push({ name: 'qna', params: { id : 'add' } })" class="btn-add"> 作成する </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
